export const ImgURL = process.env.REACT_APP_ASSET_URL || "https://backend.zayadryfruits.com/";

export const R2_CDN_URL = process.env.REACT_APP_R2_CDN_URL || "https://pub-637199cd2a854f238fa3851cb12f9eb1.r2.dev";

export const URL = process.env.REACT_APP_API_URL || "https://backend.zayadryfruits.com/api";

// .htaccess force-redirects www -> non-www, so the canonical origin has no
// "www." — og:url/JSON-LD "url" fields and <link rel="canonical"> must all
// point here, never at a URL that 301s away from itself.
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://zayadryfruits.com";
